module.exports = __webpack_public_path__ + "static/media/kn.7304fe45.svg";